import React from 'react'

import './FilterBar.css'

interface FilterBarProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
}

interface FilterFieldProps {
    label: React.ReactNode
    children: React.ReactNode
    className?: string
    testId?: string
}

interface FilterSectionProps {
    children: React.ReactNode
    className?: string
    testId?: string
    title?: React.ReactNode
    variant?: 'stack' | 'inline'
}

interface FilterActionsProps {
    children: React.ReactNode
    align?: 'left' | 'right'
    className?: string
    testId?: string
}

const joinClassNames = (...classNames: Array<string | undefined>) =>
    classNames.filter(Boolean).join(' ')

export const FilterBar: React.FC<FilterBarProps> = ({
    children,
    className,
    ...restProps
}) => (
    <div className={joinClassNames('filter-bar', className)} {...restProps}>
        <div className="filter-bar-content">{children}</div>
    </div>
)

export const FilterField: React.FC<FilterFieldProps> = ({
    label,
    children,
    className,
    testId = 'filter-field',
}) => (
    <div
        className={joinClassNames('filter-field', className)}
        data-testid={testId}
    >
        <span className="filter-field-label">{label}</span>
        <div className="filter-field-control">{children}</div>
    </div>
)

export const FilterSection: React.FC<FilterSectionProps> = ({
    children,
    className,
    testId = 'filter-section',
    title,
    variant = 'stack',
}) => (
    <div
        className={joinClassNames(
            'filter-section',
            `filter-section-${variant}`,
            className
        )}
        data-testid={testId}
    >
        {title ? <div className="filter-section-title">{title}</div> : null}
        <div className="filter-section-body">{children}</div>
    </div>
)

export const FilterActions: React.FC<FilterActionsProps> = ({
    align = 'right',
    children,
    className,
    testId = 'filter-actions',
}) => (
    <div
        className={joinClassNames(
            'filter-actions',
            `filter-actions-${align}`,
            className
        )}
        data-testid={testId}
    >
        {children}
    </div>
)

export default FilterBar
